import script from "./EventReservation.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventReservation.vue?vue&type=script&setup=true&lang=ts"

import "./EventReservation.vue?vue&type=style&index=0&id=73d8903a&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d8903a"]])

export default __exports__